var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlashOffSolid = function SvgFlashOffSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l4.354 4.354-3.345 4.014c-.154.185-.31.373-.424.538-.108.155-.304.462-.31.864a1.5 1.5 0 0 0 .557 1.19c.313.253.674.298.863.315.2.018.443.018.684.018h6.195l-.86 6.876a1 1 0 0 0 1.761.764l4.3-5.159 4.225 4.226a1 1 0 0 0 1.414-1.414l-18-18Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.639 14.396 2.059-2.471c.154-.185.31-.373.424-.538.108-.155.304-.462.31-.864a1.5 1.5 0 0 0-.557-1.19c-.313-.253-.674-.298-.863-.315C19.812 9 19.57 9 19.328 9h-6.085l5.396 5.396ZM13.145 8.902l.847-6.778a1 1 0 0 0-1.76-.764L9.218 4.976l3.927 3.926Z",
    fill: "currentcolor"
  })));
};
export default SvgFlashOffSolid;